import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col lg:flex-row flex-nowrap bg-gray-100 w-full h-screen" }
const _hoisted_2 = { class: "flex flex-col flex-nowrap flex-auto w-full lg:w-4/5" }
const _hoisted_3 = {
  ref: "content",
  class: "flex flex-auto w-full"
}
const _hoisted_4 = ["data-id", "src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DashboardSidebar = _resolveComponent("DashboardSidebar")!
  const _component_DashboardNavbar = _resolveComponent("DashboardNavbar")!
  const _component_Home = _resolveComponent("Home")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_DashboardSidebar, {
      "user-services": _ctx.userServices,
      class: "flex-initial",
      onOpenService: _ctx.openService
    }, null, 8, ["user-services", "onOpenService"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_DashboardNavbar, {
        class: "flex-initial",
        "opened-frames": _ctx.frames,
        "opened-tab": _ctx.openedTab,
        onTabClick: _ctx.openFrame,
        onTabClose: _ctx.closeFrame,
        onUpdateOrder: _ctx.updateFramesOrder
      }, null, 8, ["opened-frames", "opened-tab", "onTabClick", "onTabClose", "onUpdateOrder"]),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.frames.length < 1)
          ? (_openBlock(), _createBlock(_component_Home, { key: 0 }))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedFramesByDate, (frame) => {
          return (_openBlock(), _createElementBlock("iframe", {
            key: frame.id,
            "data-id": frame.id,
            src: frame.openUrl,
            class: "flex-auto w-full rounded-tl",
            style: _normalizeStyle({ display: frame.id === _ctx.openedFrame.id ? 'block' : 'none' })
          }, null, 12, _hoisted_4))
        }), 128))
      ], 512)
    ])
  ]))
}